// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1gMZm","insightsList":"newBusinessInsightsMenu_insightsList__2gnr3","active":"newBusinessInsightsMenu_active__1mx-z"};